import { FC, MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Formik, Field } from 'formik';
import { Typography, IconButton, Tooltip, Divider } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { ModalCard, ModalCardTitle, ModalCardContent, ActionButton } from '@ui/index';
import {
  $isOpenAddContactsModal,
  changeVisibilityAddContactsModal,
  addContactsInGroup,
} from '../../../models';
import type { ContactInstance } from '../../../types/contact';
import { ContactsSelectField } from '../../contacts-select';
import * as Styled from './styled';
import { useStyles } from './styles';

export const ChatAddContacts: FC<{ container: MutableRefObject<null> | null }> = ({
  container,
}) => {
  const { t } = useTranslation();
  const isOpen = useUnit($isOpenAddContactsModal);
  const classes = useStyles();

  const handleClose = () => changeVisibilityAddContactsModal(false);
  const handleSubmitForm = ({ contacts }: { contacts: ContactInstance[] }) =>
    addContactsInGroup(contacts);

  return (
    <ModalCard
      open={isOpen}
      classes={{ paper: classes.paper }}
      onClose={handleClose}
      container={container?.current}
    >
      <>
        <ModalCardTitle>
          <Styled.Header>
            <Typography variant="subtitle1" color="textPrimary" fontWeight={500}>
              {t('AddParticipantsToChat')}
            </Typography>
            <Tooltip title={t('close')}>
              <IconButton onClick={handleClose}>
                <CloseOutlined />
              </IconButton>
            </Tooltip>
          </Styled.Header>
          <Divider />
        </ModalCardTitle>
        <ModalCardContent className={classes.content}>
          <Formik
            initialValues={{
              contacts: [],
            }}
            onSubmit={handleSubmitForm}
            enableReinitialize
            render={({ values, handleSubmit }) => {
              const isSelectValue = values.contacts.length > 0;

              return (
                <Styled.ContentWrapper>
                  <Styled.ControlWrapper isSelectValue={isSelectValue}>
                    <Field
                      name="contacts"
                      component={ContactsSelectField}
                      placeholder={t('search')}
                      divider={false}
                      hideLabel
                      isMulti
                    />
                  </Styled.ControlWrapper>
                  {isSelectValue ? (
                    <Styled.ButtonWrapper>
                      <ActionButton kind="positive" onClick={handleSubmit}>
                        {t('AddSelected')}
                      </ActionButton>
                    </Styled.ButtonWrapper>
                  ) : (
                    <Styled.Content>
                      <Typography color="textPrimary" fontWeight={500} fontSize={14}>
                        {t('StartTypingTheFullNameOfThePersonYouWantToAddToTheChat')}
                      </Typography>
                    </Styled.Content>
                  )}
                </Styled.ContentWrapper>
              );
            }}
          />
        </ModalCardContent>
      </>
    </ModalCard>
  );
};
